import EditFormGroup from "components/form/EditFormGroup";
import React, { forwardRef } from "react";

export default forwardRef(function ForgotPasswordForm(
  {
    data = {},
    onChange = () => {},
    // define onchange parameter 'state', 'event', 'name-value'
    type = "state",
  },
  ref
) {
  return (
    <div>
      <EditFormGroup
        ref={ref}
        data={data}
        onChange={onChange}
        type={type}
        layout={[
          {
            name: "email",
            placeholder: "E-mail address",
            type: "email",
            required: true,
            startIcon: "EmailOutlined",
          },
        ]}
        fullWidth={true}
        direction="column"
        spacing={2}
      />
    </div>
  );
});
